export type Language = "ko" | "en" | "zh" | "ja";

export const LANGUAGES: Language[] = ["ko", "en", "zh", "ja"];

export const LANGUAGE_LABELS: Record<Language, string> = {
  ko: "한국어",
  en: "English",
  zh: "中文",
  ja: "日本語",
};

export const LANGUAGE_FLAGS: Record<Language, string> = {
  ko: "🇰🇷",
  en: "🇺🇸",
  zh: "🇨🇳",
  ja: "🇯🇵",
};
